// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Bell } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconBell(props: any) {
    return <IconBase icon={Bell} {...props} />
  }

  export default IconBell
  